import { useCallback } from "react";
import { useClientFetchCallback } from "./useClientFetch.js";
export default function useCityImage() {
    const { clientFetchCallback } = useClientFetchCallback();
    const getGenericImage = useCallback(async (iata) => {
        if (!iata)
            return undefined;
        if (Array.isArray(iata) && iata.length === 0)
            return undefined;
        const iataString = Array.isArray(iata) ? iata.join("-") : iata;
        return clientFetchCallback(`/api/cityImage?iata=${iataString}`, {
            method: "GET",
            cache: true,
            headers: { "Content-Type": "application/json" }
        })
            .then((d) => (d ? d?.[iataString] : undefined))
            .catch(() => undefined);
    }, [clientFetchCallback]);
    return {
        getGenericImage
    };
}
